import React from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../../../Components/Modal/modal';
import './employeeDeleteAward.scss';
import alertIcon from '../../../../Assets/images/svg/alert_icon.svg';
import { CANCEL_TEXT, SKILL_CERT_PROFILE } from '../../../../Constants/strings';
import UseAxios from '../../../../Api/http/http';
import { deleteAward } from '../../../../Api/request/achievements';
import { useSnackbar } from '../../../../Components/Snackbar/snackBarProvider';

const DeleteAward = ({
  modalOpen,
  handleClose,
  selectedAward,
  updatedData,
  setActiveStepAward = () => {},
}) => {
  const { snackbarOpen } = useSnackbar();

  const handleDeleteAction = async (award) => {
    try {
      const response = await UseAxios(deleteAward(award.award_id));
      if (response.data.status === 200) {
        setActiveStepAward((prevStep) => (prevStep !== 0 ? prevStep - 1 : prevStep));
        updatedData();
        handleClose();
        snackbarOpen(SKILL_CERT_PROFILE.SUCCESS_MSG, 'success');
      }
    } catch (error) {
      console.error('Error deleting award:', error);
      handleClose();
      snackbarOpen(SKILL_CERT_PROFILE.TRY_AGAIN, 'warning');
    }
  };

  return (
    <FormDialog
      open={modalOpen}
      title={SKILL_CERT_PROFILE.DELETE_AWARD}
      dialogPaperCss="delete-award-paper"
      dialogCss="delete-award-dialog"
      dialogBodycontent={
        <div className="award-delete-dialog-body">
          <div className="dialog-alert-icon">
            <img className="icon-image" src={alertIcon} alt="" />
          </div>
          <span className="dialog-message-text">
            {SKILL_CERT_PROFILE.DELETE_AWARD_MSG}
          </span>
        </div>
      }
      button1={CANCEL_TEXT}
      cancelButtonId="delete-award-cancel-btn"
      button1Action={() => handleClose()}
      button2={SKILL_CERT_PROFILE.DELETE}
      submitButtonId="delete-award-delete-btn"
      button2Action={() => handleDeleteAction(selectedAward)}
    />
  );
};

DeleteAward.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  selectedAward: PropTypes.any.isRequired,
  updatedData: PropTypes.func,
  setActiveStepAward: PropTypes.any,
};

export default DeleteAward;
